import { getUnixTime } from "date-fns";
import TCreateEditWebinar from "types/Webinar/createEditWebinar";

const webinarItemMapper = (formValues: any): TCreateEditWebinar => ({
  title: formValues.title,
  date: getUnixTime(formValues.date),
  thumbnailUrl:
    typeof formValues.thumbnailUrl === "string"
      ? formValues.thumbnailUrl
      : undefined,
  mediaUrl:
    typeof formValues.mediaUrl === "string" ? formValues.mediaUrl : undefined,
  removeThumbnailUrl: formValues.removeThumbnailUrl,
  removeMediaUrl: formValues.removeMediaUrl,
});

export default webinarItemMapper;
